// import Vue from 'vue'
// import axios from 'axios'
import VueAxios from "vue-axios";
import Qs from "qs";
Vue.use(VueAxios, axios);
axios.defaults.withCredentials = true;
axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
/* import Qs from 'qs' */
export default {
  post(url, data, baseUrl) {
    let config = {
      // 请求的接口，在请求的时候，如axios.get(url,config);这里的url会覆盖掉config中的url
      url: url,
      // 请求方法同上
      method: "post", // default
      // 基础url前缀
      baseURL: baseUrl || process.env.API_ROOT,
      transformRequest: [
        function(data) {
          // 这里可以在发送请求之前对请求数据做处理，比如form-data格式化等，这里可以使用开头引入的Qs（这个模块在安装axios的时候就已经安装了，不需要另外安装）
          data = Qs.stringify(data);
          return data;
        }
      ],
      /* transformResponse: [function (data) {
        // 这里提前处理返回的数据
        return data
      }], */
      // 请求头信息
      /* headers: {'X-Requested-With': 'XMLHttpRequest'}, */
      // parameter参数
      /* params: {
        timestamp: Date.parse(new Date()) / 1000
      }, */
      // post参数，使用axios.post(url,{},config);如果没有额外的也必须要用一个空对象，否则会报错
      // 设置超时时间
      timeout: 50000,
      // 返回数据类型
      responseType: "json" // default
    };
    return axios.post(url, data, config);
  },
  get(url, baseUrl) {
    let config = {
      // 请求的接口，在请求的时候，如axios.get(url,config);这里的url会覆盖掉config中的url
      url: url,
      // 请求方法同上
      method: "get", // default
      // 基础url前缀
      baseURL: baseUrl || process.env.API_ROOT,
      /* transformRequest: [function (data) {
       // 这里可以在发送请求之前对请求数据做处理，比如form-data格式化等，这里可以使用开头引入的Qs（这个模块在安装axios的时候就已经安装了，不需要另外安装）
       data = Qs.stringify({})
       return data
       }], */
      /* transformResponse: [function (data) {
       // 这里提前处理返回的数据
       return data
       }], */
      // 请求头信息
      /* headers: {'X-Requested-With': 'XMLHttpRequest'}, */
      // parameter参数
      /* params: {
       timestamp: Date.parse(new Date()) / 1000
       }, */
      // post参数，使用axios.post(url,{},config);如果没有额外的也必须要用一个空对象，否则会报错
      // 设置超时时间
      timeout: 50000,
      // 返回数据类型
      responseType: "json" // default
    };
    return axios.get(url, config);
  },
  postJson(url, data, baseUrl) {
    let config = {
      // 请求的接口，在请求的时候，如axios.get(url,config);这里的url会覆盖掉config中的url
      url: url,
      // 请求方法同上
      method: "post", // default
      // 基础url前缀
      baseURL: baseUrl || process.env.API_ROOT,
      /* transformRequest: [function (data) {
       // 这里可以在发送请求之前对请求数据做处理，比如form-data格式化等，这里可以使用开头引入的Qs（这个模块在安装axios的时候就已经安装了，不需要另外安装）
       data = Qs.stringify(data)
       return data
       }], */
      /* transformResponse: [function (data) {
       // 这里提前处理返回的数据
       return data
       }], */
      // 请求头信息
      headers: { "Content-Type": "application/json; charset=UTF-8" },
      // headers: {'Content-Type': 'application/json'},
      // parameter参数
      /* params: {
       timestamp: Date.parse(new Date()) / 1000
       }, */
      // post参数，使用axios.post(url,{},config);如果没有额外的也必须要用一个空对象，否则会报错
      // 设置超时时间
      timeout: 50000,
      // 返回数据类型
      responseType: "json" // default
    };
    return axios.post(url, data, config);
  },
  file(url, data, baseUrl) {
    let config = {
      // 请求的接口，在请求的时候，如axios.get(url,config);这里的url会覆盖掉config中的url
      url: url,
      // 请求方法同上
      method: "post", // default
      // 基础url前缀
      baseURL: baseUrl || process.env.API_ROOT,
      /* transformRequest: [function (data) {
       // 这里可以在发送请求之前对请求数据做处理，比如form-data格式化等，这里可以使用开头引入的Qs（这个模块在安装axios的时候就已经安装了，不需要另外安装）
       data = Qs.stringify(data)
       return data
       }], */
      /* transformResponse: [function (data) {
       // 这里提前处理返回的数据
       return data
       }], */
      // 请求头信息
      headers: { "Content-Type": "image/png" },
      // headers: {'Content-Type': 'application/json'},
      // parameter参数
      /* params: {
       timestamp: Date.parse(new Date()) / 1000
       }, */
      // post参数，使用axios.post(url,{},config);如果没有额外的也必须要用一个空对象，否则会报错
      // 设置超时时间
      timeout: 50000,
      // 返回数据类型
      responseType: "json" // default
    };
    return axios.post(url, data, config);
  },
  uploadFile(url, data, baseUrl) {
    let param = new FormData(); //创建form对象

    param.append("file", data.file); //通过append向form对象添加数据
    data.appId && param.append("appId", data.appId);
    data.columnId && param.append("columnIds", data.columnId);
    data.theirNwProductName && param.append("theirNwProductName", data.theirNwProductName);
    data.etfId && param.append("etfId", data.etfId);


    let config = {
      method: "post",
      url: url,
      baseURL: baseUrl || process.env.API_ROOT,
      // data: qs.stringify(data),
      timeout: 50000,
      responseType: "json",
      headers: { "Content-Type": "multipart/form-data" }
    };
    return axios.post(url, param, config);
  },
  sendMail(url, data, baseUrl) {
    let param = new FormData(); //创建form对象
    for (const key in data) {
      if (data.hasOwnProperty(key)) {
        if (key == "file") {
          data[key].forEach(item => {
            param.append("file[]", item, item.unicodeName);
          });
        } else {
          param.append(key, data[key]);
        }
      }
    }

    let config = {
      method: "post",
      url: url,
      baseURL: baseUrl || process.env.API_ROOT,
      // data: qs.stringify(data),
      responseType: "json",
      headers: { "Content-Type": "multipart/form-data" }
    };
    return axios.post(url, param, config);
  },
  fileStream(url, data, baseUrl) {
    let config = {
      url: url,
      method: "post", // default
      baseURL: baseUrl || process.env.API_ROOT,
      headers: { "Content-Type": "application/octet-stream" },
    };
    return axios.post(url, data, config);
  },
  delete(url, baseUrl) {
    let config = {
      // 请求的接口，在请求的时候，如axios.get(url,config);这里的url会覆盖掉config中的url
      url: url,
      // 请求方法同上
      method: "delete", // default
      // 基础url前缀
      baseURL: baseUrl || process.env.API_ROOT,
      /* transformRequest: [function (data) {
       // 这里可以在发送请求之前对请求数据做处理，比如form-data格式化等，这里可以使用开头引入的Qs（这个模块在安装axios的时候就已经安装了，不需要另外安装）
       data = Qs.stringify({})
       return data
       }], */
      /* transformResponse: [function (data) {
       // 这里提前处理返回的数据
       return data
       }], */
      // 请求头信息
      /* headers: {'X-Requested-With': 'XMLHttpRequest'}, */
      // parameter参数
      /* params: {
       timestamp: Date.parse(new Date()) / 1000
       }, */
      // post参数，使用axios.post(url,{},config);如果没有额外的也必须要用一个空对象，否则会报错
      // 设置超时时间
      timeout: 50000,
      // 返回数据类型
      responseType: "json" // default
    };
    return axios.delete(url, config);
  },
  put(url, data, baseUrl) {
    let config = {
      // 请求的接口，在请求的时候，如axios.get(url,config);这里的url会覆盖掉config中的url
      url: url,
      // 请求方法同上
      method: "put", // default
      // 基础url前缀
      baseURL: baseUrl || process.env.API_ROOT,
      /* transformRequest: [function (data) {
       // 这里可以在发送请求之前对请求数据做处理，比如form-data格式化等，这里可以使用开头引入的Qs（这个模块在安装axios的时候就已经安装了，不需要另外安装）
       data = Qs.stringify({})
       return data
      }], */
      /* transformResponse: [function (data) {
       // 这里提前处理返回的数据
       return data
       }], */
      // 请求头信息
      /* headers: {'X-Requested-With': 'XMLHttpRequest'}, */
      // parameter参数
      /* params: {
       timestamp: Date.parse(new Date()) / 1000
       }, */
      // post参数，使用axios.post(url,{},config);如果没有额外的也必须要用一个空对象，否则会报错
      // 设置超时时间
      timeout: 50000,
      // 返回数据类型
      responseType: "json" // default
    };
    return axios.put(url, data, config);
  }
};



// WEBPACK FOOTER //
// ./src/api/ajax.js